import { FeeType } from "./FeeType";
export const blackBoxProductsUrl = process.env.GATSBY_API_URL + "/blackbox/products";
export const blackBoxTabbedRateUrl = process.env.GATSBY_API_URL + "/rates/tabbed/";
export const fhaRatesUrl = process.env.GATSBY_API_URL + "/blackbox/fhaRates/";
export const mrqtStatesUrl = process.env.GATSBY_API_URL + "/directory/mrqtStates";
export const countiesUrl = process.env.GATSBY_API_URL + "/directory/counties";
export const mortgageRateUrl = process.env.GATSBY_API_URL + "/table/mortgage_loan_limits";
export const mortgageLtvUrl = process.env.GATSBY_API_URL + "/table/mortgage_loan_to_value";
export const numValidResults = 3; //The minimum number of results needed for a LoanType
export const defaultFinancedUnitCount = 1;
export const blackBoxEnumUrl = (param) => `${process.env.GATSBY_API_URL}/blackbox/enum/${param}`;

//VARS
export const CONSTANTS = {
    STATE: "State",
    COUNTY: "County",
    PURCHASE_PRICE: "Purchase price",
    PURCHASE_PRICE_ID: "PurchasePrice",
    DOWN_PAYMENT: "Down payment",
    DOWN_PAYMENT_ID: "DownPayment",
    REFINANCE_AMT: "Refinance Amount",
    REFINANCE_AMT_ID: "RefinanceAmount",
    CURRENT_VALUE: "Current Home Value",
    CURRENT_VALUE_ID: "CurrentHomeValue",
    PROPERTY_TAX: "propertyTax",
    HOMEOWNERS_INSURANCE: "homeownersInsurance",
    PURCHASE: "Purchase",
    REFINANCE: "Refinance",
    LOAN_PURPOSE: "Loan Purpose",
    LOAN_PURPOSE_ID: "LoanPurpose",
    DEFAULT_LOAN_AMOUNT_CODE: "default",
    MAX_FIRST_TIME_AMOUNT_CODE: "firsttime_homebuyer_loan_limit",
};

export const loanPurposeTypes = {
    PURCHASE: "Purchase",
    REFINANCE_CASH_OUT: "RefiCashout",
    REFINANCE_RATE_TERM_LIMITED: "RefiRateTermLimitedCO"
};

export const propertyUsageTypes = {
    INVESTMENT_PROPERTY: "InvestmentProperty",
    PRIMARY_RESIDENCE: "PrimaryResidence",
    SECOND_HOME: "SecondHome"
};

export const formElements = {
    LoanPurpose: { value: "Purchase", isValid: true, required: true },
    State: { value: 45, isValid: true, required: true },
    County: { value: null, isValid: false, required: true },
    CreditScore: { value: 741, isValid: true, required: true },
    PropertyType: { value: "SingleFamily", isValid: true, required: true },
    PropertyUsageType: { value: "PrimaryResidence", isValid: true, required: true },
    PurchasePrice: { value: "200000", isValid: true, required: true },
    DownPayment: { value: "50000", isValid: true, required: true },
    CurrentHomeValue: { value: "200000", isValid: true, required: true },
    RefinanceAmount: { value: "50000", isValid: true, required: true },
    FinancedUnitCount: { value: 1, isValid: true, required: false },
    PropertyTax: { value: 0, isValid: true, required: false },
    Insurance: { value: 0, isValid: true, required: false },
    LoanAmount: { value: null, isValid: true, required: false },
    LoanTerm: { value: 17, isValid: false, required: true },
    FirstTimeLimit: { value: 0, isValid: true, required: true },
    DefaultLoanLimit: { value: 0, isValid: true, required: true },
    LoanLimit: { value: 0, isValid: true, required: true },
};

export const emailFormValues = {
    FirstName: { value: "", isValid: false, required: true },
    LastName: { value: "", isValid: false, required: true },
    Email: { value: "", isValid: false, required: true },
};

export enum MortgageCategory {
    ARM,
    FTHB_ARM,
    FIXED_MORTAGE,
    CONSTRUCTION,
    FTHB,
    REFINANCE,
    FHA,
    VA,
    LOT,
    JUMBO,
    USDA,
    SECOND_MORTGAGE,
};

export enum LoanType {
    Conforming = "Conforming",
    NonConforming = "NonConforming",
    USDARuralHousing = "USDARuralHousing",
    FHA = "FHA",
    VA = "VA",
    Conventional = "Conventional",
};

export enum AutomatedUnderwritingSystem {
    DU = "DU",
    LP = "LP",
    ManualTraditional = "ManualTraditional",
    NotSpecified = "NotSpecified",
    InvestorAus = "InvestorAus",
};

export enum ConstructionLoanType {
    ConstructionToPermanent = "ConstructionToPerm",
    NotApplicable = "NotApplicable",
    Construction = "Construction",
};